import { NO_DATA } from "./scenarioConstants";

export const formatPercentage = (
  percentage: number | null,
  showNoDecimal: boolean = false
): string => {
  if (percentage === null) {
    return NO_DATA;
  }

  if (percentage === 0) {
    return "0%";
  }

  return `${percentage.toLocaleString("en-US", {
    maximumFractionDigits: showNoDecimal ? 0 : 2,
  })}%`;
};

export const formatPercentageFromFraction = (
  fraction: number,
  showNoDecimal: boolean = false
): string => {
  if (fraction === 0) {
    return "0%";
  }

  return `${(fraction * 100).toLocaleString("en-US", {
    maximumFractionDigits: showNoDecimal ? 0 : 2,
  })}%`;
};
